import Section from '@app/components/atoms/Section/Section'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

export default function RequestedVoucherPOS() {
  const {
    props: { pos, routeName, voucher },
  } = usePage()
  const { t } = useTranslation()

  return (
    <Section simple>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5">{t('VOUCHER.LIST_POS')} </Typography>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            enableIndexColumn
            columns={[
              {
                id: 'address',
                Header: t('POS.ADDRESS'),
                accessor: 'address',
                type: 'string',
              },
              {
                id: 'city',
                Header: t('POS.CITY'),
                accessor: 'city',
                type: 'string',
              },
              {
                id: 'longitude',
                Header: t('POS.LONGITUDE'),
                accessor: 'longitude',
                type: 'string',
                disableFilters: true,
                disableSortBy: true,
              },
              {
                id: 'latitude',
                Header: t('POS.LATITUDE'),
                accessor: 'latitude',
                type: 'string',
                disableFilters: true,
                disableSortBy: true,
              },
            ]}
            data={pos}
            enableCollapseFilter={false}
            params={{ campaign: voucher.campaign_id, merchant: voucher.merchant_id, voucher: voucher.id }}
            queries={{
              campaign: voucher.campaign_id,
              merchant: voucher.merchant_id,
              voucher: voucher.id,
            }}
            routeName={routeName}
          />
        </Grid>
      </Grid>
    </Section>
  )
}
